export default {
	product: {
		name: '',
		num: 0
	},
	payment: null
}